var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.25C11.4518 14.25 14.25 11.4518 14.25 8C14.25 4.54822 11.4518 1.75 8 1.75C4.54822 1.75 1.75 4.54822 1.75 8C1.75 11.4518 4.54822 14.25 8 14.25ZM7.11987 8.00962L6.19813 8.93686C6.13862 8.99469 6.09122 9.06379 6.0587 9.14013C6.02618 9.21647 6.00918 9.29852 6.00871 9.3815C6.00823 9.46447 6.02428 9.54671 6.05592 9.62342C6.08756 9.70013 6.13416 9.76977 6.19301 9.82828C6.25184 9.88679 6.32175 9.93299 6.39863 9.9642C6.47552 9.99541 6.55785 10.011 6.64082 10.01C6.72379 10.0091 6.80575 9.99164 6.8819 9.95869C6.95806 9.92573 7.02689 9.87795 7.08438 9.81811L8.00172 8.8953L8.90125 9.79876C9.0182 9.91629 9.17704 9.98254 9.34283 9.98295C9.50862 9.98336 9.66779 9.91789 9.78531 9.80095C9.90284 9.684 9.96909 9.52516 9.9695 9.35937C9.96991 9.19358 9.90445 9.03441 9.7875 8.91689L8.88295 8.00881L9.80938 7.07686C9.92294 6.95867 9.98552 6.8006 9.98365 6.63671C9.98178 6.47282 9.91561 6.31622 9.79938 6.20065C9.68316 6.08508 9.52619 6.01979 9.36229 6.01885C9.19838 6.01791 9.04067 6.08139 8.92313 6.19561L8.00091 7.12333L7.0625 6.18126C6.94487 6.06714 6.78712 6.00378 6.62323 6.00485C6.45934 6.00592 6.30243 6.07131 6.18629 6.18696C6.07016 6.3026 6.00409 6.45924 6.00233 6.62312C6.00057 6.787 6.06325 6.94502 6.17688 7.06314L7.11987 8.00962Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCancel);
export default __webpack_public_path__ + "static/media/productCancel.fec2bceb1c96771a85bec612b76c6105.svg";
export { ForwardRef as ReactComponent };